class EnvService {
  get = () => process.env.ENVIRONMENT
  isLocal = () => this.get() === 'local'
  isProduction = () => this.get() === 'production'
  isStaging = () => this.get() === 'staging'
}

export const envService = new EnvService()
